module.exports = __webpack_public_path__ + "img/collectorbank@2x.57db0ca.png";